import React from 'react';
import { useAuth } from '../contexts/authContext';
import { Navigate } from 'react-router-dom';
import UnifiedSidebar from '../components/UnifiedSidebar';
import './Sidebar.css';

const menuSections = [
  {
    section: '',
    items: [
      {
        id: 'home',
        label: 'Home',
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
        ),

      },
      {
        id: 'birthdays',
        label: 'Birthdays',
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7"></path>
            <path d="M4 12h16"></path>
            <path d="M12 2v4"></path>
            <path d="M8 2v4"></path>
            <path d="M16 2v4"></path>
          </svg>
        ),

      },
      {
        id: 'groups',
        label: 'Groups',
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
        ),

      },
      {
        id: 'events',
        label: 'Events',
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
        ),

      },
      {
        id: 'profile',
        label: 'My Profile',
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
        ),

      },
      {
        id: 'discover',
        label: 'Discover',
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>
          </svg>
        ),

      },
      {
        id: 'virtualcafe',
        label: 'Virtual Café',
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 8h1a4 4 0 0 1 0 8h-1"></path>
            <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path>
            <line x1="6" y1="1" x2="6" y2="4"></line>
            <line x1="10" y1="1" x2="10" y2="4"></line>
            <line x1="14" y1="1" x2="14" y2="4"></line>
          </svg>
        ),

      },
      {
        id: 'academy',
        label: 'Academy',
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
          </svg>
        ),

      },
      {
        id: 'eBookstore',
        label: 'eBookstore',
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
            <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
          </svg>
        ),

      },
      {
        id: 'about',
        label: 'About Us',
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
        ),

      },
    ],
  },
];

import { useNavigate } from 'react-router-dom';

const Sidebar = ({ activeSection, onSectionChange, onLogout, onToggleSidebar = () => {} }) => {
  const { user, loading } = useAuth();
  
  // Show loading state while auth is loading
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading">Loading...</div>
      </div>
    );
  }
  
  // Only redirect if user is confirmed unauthenticated
  if (!user) {
    return <Navigate to="/" replace />;
  }

  const navigate = useNavigate();

  // Map section IDs to routes
  const sectionToRoute = {
    home: '/app/home',
    groups: '/app/groups',
    events: '/app/events',
    profile: '/app/profile',
    discover: '/app/discover',
    birthdays: '/app/birthdays',
    virtualcafe: '/app/virtualcafe',
    academy: '/app/academy',
    eBookstore: '/app/eBookstore',
    about: '/app/about',
  };


  // Enhance menuSections with navigation
  const navMenuSections = menuSections.map(section => ({
    ...section,
    items: section.items.map(item => ({
      ...item,
      onClick: () => {
        if (onSectionChange) onSectionChange(item.id);
        if (sectionToRoute[item.id]) navigate(sectionToRoute[item.id]);
      },
    })),
  }));

  return (
    <UnifiedSidebar
      menuSections={navMenuSections}
      showRoleSwitcher={false}
      onLogout={onLogout}
      logoText="VirtuLingu"
      showHome={false} // Home is included as a regular nav item
      activeSection={activeSection}
      onCollapseChange={onToggleSidebar}
    />
  );
};

export default React.memo(Sidebar);
